// Shared REST client for the free public exchanges proxied through our own
// backend (server/exchanges/market_proxy.js) rather than called directly
// from the browser, so we don't depend on each upstream's CORS policy and
// so repeated requests across tabs/users share one small server-side cache.
const API_BASE = process.env.VUE_APP_API_BASE || '';

export async function loadMarketSymbols(exchange) {
    const response = await fetch(API_BASE + '/api/market/' + exchange + '/symbols');
    const data = await response.json();
    if (!data || !data.success) throw new Error((data && data.error) || ('Failed to load ' + exchange + ' symbols'));
    return data.symbols || [];
}

export async function loadMarketKlines(exchange, symbol, tf, endTime) {
    const params = new URLSearchParams({ symbol, tf: tf || '1D' });
    if (Number.isFinite(endTime)) params.set('endTime', endTime);
    const response = await fetch(API_BASE + '/api/market/' + exchange + '/klines?' + params.toString());
    const data = await response.json();
    if (!data || !data.success) throw new Error((data && data.error) || ('Failed to load ' + exchange + ' candles'));
    return data.candles || [];
}
